import "@/App.css";

function App() {
  return (
    <div className="published-page-shell" data-testid="published-page-shell">
      <iframe
        data-testid="published-page-iframe"
        title="Published Shareable Page"
        src="/shared-page.html"
        className="published-page-iframe"
        sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation"
        referrerPolicy="no-referrer"
      />
    </div>
  );
}

export default App;
